'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

exports['default'] = function () {
  var Snap = undefined;
  try {
    Snap = require('snapsvg-cjs');
  } finally {
    return Snap;
  }
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-burger-menu/lib/snapsvgImporter.js
// module id = 216
// module chunks = 168707334958949